import { h, Fragment } from "preact";

import Icon from "./Icon";

export function PoweredBy3Play() {
  return (
    <a href="https://www.3playmedia.com/" class="PoweredBy">
      <span>Powered by</span>
      <Icon type="logo-black" style="svg" />
    </a>
  );
}
